var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: {
        id: _vm.popupId,
        tabindex: "-1",
        role: "dialog",
        "aria-labelledby": "myLargeModalLabel",
        "aria-hidden": "true"
      }
    },
    [
      _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c("h2", { staticStyle: { "font-size": "24px" } }, [
              _vm._v("Send Email For New Feature/Bug Fixed?")
            ]),
            _c("button", {
              ref: "clearBlockedUsersPopupCloseButton",
              staticClass: "close",
              attrs: {
                type: "button",
                "data-dismiss": "modal",
                "aria-label": "Close"
              }
            })
          ]),
          _c("div", { staticClass: "modal-body" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-xs-6" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn-lg-grey",
                    on: {
                      click: function($event) {
                        return _vm.SendEmailToIOSUsers("android")
                      }
                    }
                  },
                  [
                    _c("img", {
                      staticClass: "operator_img",
                      attrs: { src: "/img/android.png" }
                    }),
                    _vm._v(" ANDROID")
                  ]
                )
              ]),
              _c("div", { staticClass: "col-xs-6" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn-lg-grey",
                    on: {
                      click: function($event) {
                        return _vm.SendEmailToIOSUsers("ios")
                      }
                    }
                  },
                  [
                    _c("img", {
                      staticClass: "operator_img",
                      attrs: { src: "/img/apple.png" }
                    }),
                    _vm._v(" IOS")
                  ]
                )
              ])
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }